import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import store from "./store";
import store from "./store/index";
import ElementUI from "element-ui";
import md5 from "js-md5";
import "./assets/js/directives.js"; // 自定义指令

import "./assets/css/public.css";
import "./assets/font/iconfont.css";
import "./assets/icon-font/iconfont.css";
import "./lib/axios";
import "element-ui/lib/theme-chalk/index.css";

Vue.prototype.$md5 = md5;
Vue.config.productionTip = false;
Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
